import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./ModalPDF.scss";
import expensesService from "../../services/expenses";

function ModalPDF({ onCloseModal, url }) {
  const [urlConcat, setUrlConcat] = useState(null);

  useEffect(() => {
    // bloqueia scroll do body enquanto a modal está aberta
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  useEffect(() => {
    const fetchUrl = async () => {
      try {
        const response = await expensesService.getAccessAuthorizationAWS(url);
        setUrlConcat(response.data);
      } catch (error) {
        console.error("Erro ao buscar URL assinada:", error);
      }
    };
    if (url) fetchUrl();
  }, [url]);

  const iframeHTML = `
    <iframe
      title="Documento"
      frameborder="0"
      style="width:100%;height:100%;border:0;display:block;"
      src="${urlConcat || ""}"
    ></iframe>
  `;

  const modal = (
    <div className="pdf-modal-overlay" onClick={() => onCloseModal(false)}>
      <div
        className="pdf-modal-card"
        onClick={(e) => e.stopPropagation()}
        // Fallback hard caso algum CSS externo tente sobrescrever
        style={{ width: "80vw", height: "90vh" }}
      >
        <button
          className="pdf-modal-close"
          onClick={() => onCloseModal(false)}
          aria-label="Fechar"
        >
          ×
        </button>

        {/* Conteúdo do PDF */}
        <div
          className="pdf-modal-content"
          dangerouslySetInnerHTML={{ __html: iframeHTML }}
        />
      </div>
    </div>
  );

  // Renderiza no body para evitar interferência de pais
  return ReactDOM.createPortal(modal, document.body);
}

export default ModalPDF;
